<ng-container *ngIf="visible">
  <div class="capitalize-first-letter inline-block mr-8">{{getLabel()}}:</div> 
  <div class="{{getRecordState()}} inline-block">{{getSensorText()}}</div> 
</ng-container>